import React from 'react';
import axios from 'axios';
import { Card,Avatar} from 'antd';
import { Form, Input, Button,Select,Spin,Switch,Modal,message,Popconfirm,Popover } from 'antd';
import {
    Col,
    Row,
  } from 'reactstrap';
import { UserOutlined,LoadingOutlined,PlusCircleFilled,DeleteOutlined } from '@ant-design/icons';
import * as serverconfig from '../serverconn'
import * as primarycolor from '../primarycolor'

var CryptoJS = require("crypto-js");

const FormItem=Form.Item;
const { Option } = Select;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

var token= ''
var sacco= ''



class LoanTypeDetail extends React.Component{

    state={
        loantype: {},
        loan_type_name:'',
        loan_form_fees:0,
        loan_assessment_fees:0,
        loan_insurance_fee:0,
        loan_commitment_fee:0,
        loan_agreement_fees:0,
        reserve_fees:0,
        interest_rate:0,
        maximum_loan_amount:0,
        maximum_period:0,
    
        interestrate_type:'flatinterest',
        loan_primary_schedule:'monthly',
        no_of_times_collateral_againstloanamount:0,
        no_of_approvers:0,
    
        pmt_formular_enabled_onreducingbalance:false,
    
        account_tocreditloanprinciple_ondeposit:0,
        account_tocreditloaninterest_ondeposit:0,
        account_todebitloaninterest_ondeposit:0,
    
        account_todebit_onloan_onloanissuance:0,
        account_tocredit_onloanfees_onloanissuance:0,
        account_tocredit_onbankcharge_onloanissuance:0,
    
        account_todebit_on_acculatedloanfines:0,
        account_tocredit_on_paidloanfines:0,
    
        account_tocredit_onreservefee:0,
        account_tocredit_onassessment_fees:0,
        account_tocredit_oninsurance_fee:0,
        account_tocredit_oncommitment_fee:0,
        account_tocredit_onagreement_fees:0,
    
        companyaccounts:[],
        transfer_tosavings_onissuance:false,
        charges_from:'',
        send_sms_onissuance:false,
        send_sms_on_repayment:false,

        photograph_fees:0,
        account_tocredit_onphotograph_fees:0,
        loan_limitby:'',
        autoPayments_afterfullcycle:false,


        //fees variables
        range_name:'' ,  
        range_start_value:0,
        range_stop_value:0,
        charge_type:'',
        charge_value:0,

        //new
        dynamic_loanformfees:false,
        dynamic_loanformfees_list:[],
        dyform_model_visible:false,

        minimum_no_ofshares_required:0,
        minimum_savingsperiod_required:0,
        minimum_member_guarantors:0,
        sms_balancesending_mode:''

    
    }
    

    componentDidMount(){

      if(localStorage.getItem("sacco")){
        sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
      }else{
          sacco= ''
      }
     

      if(localStorage.getItem("token")){
         token= localStorage.getItem("token")
      }else{
         token= ''
      }

      axios.defaults.headers={
        "Content-Type":"application/json",
        Authorization:`Token ${token}`
      }

        const loanTypeID=this.props.match.params.loanTypeID;
        axios.get(`${serverconfig.backendserverurl}/api/loantypes/${loanTypeID}`)
        .then(res => {  
            this.setState({loantype: res.data})

            this.setState({loan_type_name: res.data.loan_type_name})
            this.setState({loan_form_fees: res.data.loan_form_fees})
            this.setState({loan_assessment_fees: res.data.loan_assessment_fees})
            this.setState({loan_insurance_fee: res.data.loan_insurance_fee})
            this.setState({loan_commitment_fee: res.data.loan_commitment_fee})
            this.setState({loan_agreement_fees: res.data.loan_agreement_fees})
            this.setState({reserve_fees: res.data.reserve_fees})
            this.setState({interest_rate: res.data.interest_rate})

            this.setState({maximum_loan_amount: res.data.maximum_loan_amount})
            this.setState({maximum_period: res.data.maximum_period})

            this.setState({interestrate_type: res.data.interestrate_type})
            this.setState({loan_primary_schedule: res.data.loan_primary_schedule})
            this.setState({no_of_times_collateral_againstloanamount: res.data.no_of_times_collateral_againstloanamount})
            this.setState({no_of_approvers: res.data.no_of_approvers})
          
            
            this.setState({pmt_formular_enabled_onreducingbalance:res.data.pmt_formular_enabled_onreducingbalance})
    
            this.setState({account_tocreditloanprinciple_ondeposit:res.data.account_tocreditloanprinciple_ondeposit})
            this.setState({account_tocreditloaninterest_ondeposit:res.data.account_tocreditloaninterest_ondeposit})
            this.setState({account_todebitloaninterest_ondeposit:res.data.account_todebitloaninterest_ondeposit})
      
            this.setState({account_todebit_onloan_onloanissuance:res.data.account_todebit_onloan_onloanissuance})
            this.setState({account_tocredit_onloanfees_onloanissuance:res.data.account_tocredit_onloanfees_onloanissuance})
            this.setState({account_tocredit_onbankcharge_onloanissuance:res.data.account_tocredit_onbankcharge_onloanissuance})
      
            this.setState({account_todebit_on_acculatedloanfines:res.data.account_todebit_on_acculatedloanfines})
            this.setState({account_tocredit_on_paidloanfines:res.data.account_tocredit_on_paidloanfines})
      
            this.setState({account_tocredit_onreservefee:res.data.account_tocredit_onreservefee})
            this.setState({account_tocredit_onassessment_fees:res.data.account_tocredit_onassessment_fees})
            this.setState({account_tocredit_oninsurance_fee:res.data.account_tocredit_oninsurance_fee})
            this.setState({account_tocredit_oncommitment_fee:res.data.account_tocredit_oncommitment_fee})
            this.setState({account_tocredit_onagreement_fees:res.data.account_tocredit_onagreement_fees})
    
            this.setState({transfer_tosavings_onissuance:res.data.transfer_tosavings_onissuance})
            this.setState({charges_from:res.data.charges_from})
            this.setState({send_sms_onissuance:res.data.send_sms_onissuance})
            this.setState({send_sms_on_repayment:res.data.send_sms_on_repayment})

            this.setState({photograph_fees:res.data.photograph_fees})
            this.setState({account_tocredit_onphotograph_fees:res.data.account_tocredit_onphotograph_fees})

            this.setState({loan_limitby:res.data.loan_limitby})
            this.setState({autoPayments_afterfullcycle:res.data.autoPayments_afterfullcycle})

              //new

            this.setState({dynamic_loanformfees:res.data.dynamic_loanformfees})
            this.setState({dynamic_loanformfees_list:res.data.dynamic_loanformfees_list!=null? JSON.parse(res.data.dynamic_loanformfees_list):[] })

          this.setState({minimum_no_ofshares_required:res.data.minimum_no_ofshares_required})
          this.setState({minimum_savingsperiod_required:res.data.minimum_savingsperiod_required})
          this.setState({minimum_member_guarantors:res.data.minimum_member_guarantors})


          this.setState({sms_balancesending_mode:res.data.sms_balancesending_mode})
          
          //  this.setState({datarequested:false})
        })


    axios.get(serverconfig.backendserverurl+`/api/companyaccounts/?sacco=${sacco}`)
    .then(res => {
        this.setState({
            companyaccounts:res.data
        })
        this.setState({datarequested:false})
    })
    }

    //submit button pressed
  handleFormSubmit=(event) =>{
    this.setState({datarequested:true})

    const loanTypeID=this.props.match.params.loanTypeID;
    let form_data = new FormData();

    form_data.append('loan_type_name', this.state.loan_type_name);
    form_data.append('loan_form_fees', this.state.loan_form_fees);

    form_data.append('loan_assessment_fees', this.state.loan_assessment_fees);
    form_data.append('loan_insurance_fee', this.state.loan_insurance_fee);
    form_data.append('loan_commitment_fee', this.state.loan_commitment_fee);
    form_data.append('loan_agreement_fees', this.state.loan_agreement_fees);
    form_data.append('reserve_fees', this.state.reserve_fees);
    form_data.append('interest_rate', this.state.interest_rate);
    form_data.append('maximum_loan_amount', this.state.maximum_loan_amount);
    form_data.append('maximum_period', this.state.maximum_period);

    form_data.append('loan_primary_schedule', this.state.loan_primary_schedule);
    form_data.append('interestrate_type', this.state.interestrate_type);
    form_data.append('no_of_times_collateral_againstloanamount', this.state.no_of_times_collateral_againstloanamount);
    form_data.append('no_of_approvers', this.state.no_of_approvers);

    //new additions now
    form_data.append('pmt_formular_enabled_onreducingbalance', this.state.pmt_formular_enabled_onreducingbalance);
    form_data.append('transfer_tosavings_onissuance', this.state.transfer_tosavings_onissuance);

    form_data.append('account_tocreditloanprinciple_ondeposit', this.state.account_tocreditloanprinciple_ondeposit);
    form_data.append('account_tocreditloaninterest_ondeposit', this.state.account_tocreditloaninterest_ondeposit);
    form_data.append('account_todebitloaninterest_ondeposit', this.state.account_todebitloaninterest_ondeposit);

    form_data.append('account_todebit_onloan_onloanissuance', this.state.account_todebit_onloan_onloanissuance);
    form_data.append('account_tocredit_onloanfees_onloanissuance', this.state.account_tocredit_onloanfees_onloanissuance);
    form_data.append('account_tocredit_onbankcharge_onloanissuance', this.state.account_tocredit_onbankcharge_onloanissuance);

    form_data.append('account_todebit_on_acculatedloanfines', this.state.account_todebit_on_acculatedloanfines);
    form_data.append('account_tocredit_on_paidloanfines', this.state.account_tocredit_on_paidloanfines);

    form_data.append('account_tocredit_onreservefee', this.state.account_tocredit_onreservefee);
    form_data.append('account_tocredit_onassessment_fees', this.state.account_tocredit_onassessment_fees);
    form_data.append('account_tocredit_oninsurance_fee', this.state.account_tocredit_oninsurance_fee);
    form_data.append('account_tocredit_oncommitment_fee', this.state.account_tocredit_oncommitment_fee);
    form_data.append('account_tocredit_onagreement_fees', this.state.account_tocredit_onagreement_fees);
    form_data.append('charges_from', this.state.charges_from);
    form_data.append('send_sms_onissuance', this.state.send_sms_onissuance);
    form_data.append('send_sms_on_repayment', this.state.send_sms_on_repayment);


    form_data.append('photograph_fees', this.state.photograph_fees);
    form_data.append('account_tocredit_onphotograph_fees', this.state.account_tocredit_onphotograph_fees);
    form_data.append('loan_limitby', this.state.loan_limitby);
    form_data.append('autoPayments_afterfullcycle', this.state.autoPayments_afterfullcycle);


    //new
    form_data.append('dynamic_loanformfees', this.state.dynamic_loanformfees);
    form_data.append('dynamic_loanformfees_list',JSON.stringify(this.state.dynamic_loanformfees_list) );


    form_data.append('minimum_no_ofshares_required', this.state.minimum_no_ofshares_required);
    form_data.append('minimum_savingsperiod_required', this.state.minimum_savingsperiod_required);
    form_data.append('minimum_member_guarantors', this.state.minimum_member_guarantors);

    form_data.append('sms_balancesending_mode', this.state.sms_balancesending_mode);

    axios.put(serverconfig.backendserverurl+`/api/loantypes/${loanTypeID}/`, form_data, {
      headers: {
        'content-type': 'multipart/form-data'
      }
    })
  .then(res =>this.setState({datarequested:false}),window.location.reload(false)

  )
  .catch(error => console.log(error))

  }


  handleloan_type_nameChange= (e) => this.setState({ loan_type_name: e.target.value});
  handleloan_form_feesChange= (e) => this.setState({ loan_form_fees: e.target.value});
  handleloan_assessment_feesChange= (e) => this.setState({ loan_assessment_fees: e.target.value});
  handleloan_insurance_feeChange= (e) => this.setState({ loan_insurance_fee: e.target.value});
  handleloan_commitment_feeChange= (e) => this.setState({ loan_commitment_fee: e.target.value});
  handleloan_agreement_feesChange= (e) => this.setState({ loan_agreement_fees: e.target.value});
  handlereserve_feesChange= (e) => this.setState({ reserve_fees: e.target.value});
  handleinterest_rateChange= (e) => this.setState({ interest_rate: e.target.value});
  handlemaximum_loan_amountChange= (e) => this.setState({ maximum_loan_amount: e.target.value});
  handlemaximum_loan_amount_first_time_borrowerChange= (e) => this.setState({ maximum_loan_amount_first_time_borrower: e.target.value});
  handlemaximum_periodChange= (e) => this.setState({ maximum_period: e.target.value});
  handlemaximum_period_first_time_borrowerChange= (e) => this.setState({ maximum_period_first_time_borrower: e.target.value});
  handlepercentage_payment_of_currentloan_before_top_upChange= (e) => this.setState({ percentage_payment_of_currentloan_before_top_up: e.target.value});


  //add to list of form 
  handleFormSubmit_listofformfees=(event) =>{
    
    var intobj={
      'key':this.state.dynamic_loanformfees_list.length+1,
      'range_name':this.state.range_name,
      'range_start_value':this.state.range_start_value,
      'range_stop_value':this.state.range_stop_value,
      'charge_type':this.state.charge_type,
      'charge_value':this.state.charge_value,
      }

      this.setState({dynamic_loanformfees_list: [...this.state.dynamic_loanformfees_list,intobj]});
      message.info("item added")

      this.setState({dyform_model_visible:false})

  }



    render(){

        if(this.state.datarequested===true){
            return(
              <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
              <Spin size="large">
                <div className="content" />
              </Spin>                 </div>
            )
      
          }else{

            return(
                <div>
        


        <Card 
          style={{padding:10}}
          hoverable>
            <h4>Loan Type Details / Update</h4>
            <Form
                onFinish={(event) => this.handleFormSubmit(event)} 
                >
            <FormItem label="Loan Type Name" >
              <Input name="loan_type_name"  placeholder="Put a name here." value={this.state.loan_type_name} onChange={this.handleloan_type_nameChange} />
            </FormItem>

            <FormItem label="Dyanamic loan formfees?" >
                <Switch
                    checked={this.state.dynamic_loanformfees}
                    onChange={val=>{this.setState({dynamic_loanformfees:val})}}
                    checkedChildren="True"
                    unCheckedChildren="False"
                    />
            </FormItem>   

            {
              this.state.dynamic_loanformfees?
              <div>
                <FormItem label=  {"Click to add range"}>
                <PlusCircleFilled 
                style={{fontSize: '35px',margin:2,color:primarycolor}}
                onClick={()=>{
                  this.setState({dyform_model_visible:true})
                }}
                />
                </FormItem>

              
                {
                this.state.dynamic_loanformfees_list.length>0?
                <div >
                  {
                    this.state.dynamic_loanformfees_list.map((item)=>{
                      return (
                      <p>{item.key} | {item.range_name} | from {item.range_start_value} to {item.range_stop_value} | {item.charge_type} |  {item.charge_value}&nbsp;&nbsp;
                      <Popover content={<p>Click here to delete item</p>} title="Delete">
                      <Popconfirm title="Sure to delete?" onConfirm={() => {
                        this.setState({ dynamic_loanformfees_list:  [...this.state.dynamic_loanformfees_list.filter(todo => todo.key
                          !==item.key)]});
                      }}>
                        <DeleteOutlined style={{color:'red'}}/>
                      </Popconfirm>
                      </Popover>
                      
                      </p>)
                    })
                  }

                </div>
                :
                null
              }



              </div>
              :
              <FormItem label="Loan Form Fees">
                <Input name="loan_form_fees"  placeholder="Block Figure eg 1000" value={this.state.loan_form_fees} onChange={this.handleloan_form_feesChange} />
              </FormItem>
            }         


            <FormItem label="Loan Processing Fees (Assessment)"
                     
            >
              <Input name="loan_assessment_fees"  placeholder="Enter % value" value={this.state.loan_assessment_fees} onChange={this.handleloan_assessment_feesChange} />
            </FormItem>
  
            <FormItem label="Loan Protection Fees (Insurance)"
                     
            >
              <Input name="loan_insurance_fee"  placeholder="Enter % value" value={this.state.loan_insurance_fee} onChange={this.handleloan_insurance_feeChange} />
            </FormItem>

            <FormItem label="Loan Commitment fees"
                       
            >
              <Input name="loan_commitment_fee"  placeholder="Enter % value" value={this.state.loan_commitment_fee} onChange={(val)=>{this.setState({loan_commitment_fee:val.target.value})}} />
            </FormItem>

            <FormItem label="Loan Agreement fees"
                      
            >
              <Input name="loan_agreement_fees"  placeholder="Enter % value" value={this.state.loan_agreement_fees} onChange={(val)=>{this.setState({loan_agreement_fees:val.target.value})}} />
            </FormItem>


            <FormItem label="Loan Reserve Fee (Savings loan security)" >
              <Input name="reserve_fees"  placeholder="Enter % value" value={this.state.reserve_fees} onChange={this.handlereserve_feesChange} />
            </FormItem>

            <FormItem label="Photograph Fee (Optional)" >
              <Input name="photograph_fees"  placeholder="Enter % value" value={this.state.photograph_fees} onChange={(val)=>{this.setState({photograph_fees:val.target.value})}} />
            </FormItem>


            <FormItem label="Interest Rate (Annual)">
              <Input name="interest_rate"  placeholder="Enter % value" value={this.state.interest_rate} onChange={this.handleinterest_rateChange} />
            </FormItem>

            <FormItem label="Maximum Loan Amount"
                        
            >
              <Input name="maximum_loan_amount"  placeholder="0.00" value={this.state.maximum_loan_amount} onChange={this.handlemaximum_loan_amountChange} />
            </FormItem>


            <FormItem label="Maximum Loan Period">
              <Input name="maximum_period"  placeholder="0" value={this.state.maximum_period} onChange={this.handlemaximum_periodChange} />
            </FormItem>

          {/* new changes*/ }
            <FormItem label="Minimum number of shares required">
              <Input name="minimum_no_ofshares_required"  placeholder="minimum_no_ofshares_required" value={this.state.minimum_no_ofshares_required} onChange={(val)=>{this.setState({minimum_no_ofshares_required:val.target.value})}} />
            </FormItem>

            <FormItem label="Minimum savings period(Months)">
              <Input name="minimum_savingsperiod_required"  placeholder="minimum_savingsperiod_required" value={this.state.minimum_savingsperiod_required} onChange={(val)=>{this.setState({minimum_savingsperiod_required:val.target.value})}} />
            </FormItem>


            <FormItem label="Minimum number of member guarantors">
              <Input name="minimum_member_guarantors"  placeholder="minimum_member_guarantors" value={this.state.minimum_member_guarantors} onChange={(val)=>{this.setState({minimum_member_guarantors:val.target.value})}} />
            </FormItem>



            {/* new formulas  */ }
            <FormItem 
                label="Interest rate Type"
                >
                    <Select 
                    value={this.state.interestrate_type} 
                    onChange={(val)=>{this.setState({interestrate_type:val})}}
                    placeholder="Interest rate Type" >
                      <Option value='flatinterest'>Flat Interest</Option>
                      <Option value='reducingBalanceInterest'>Reducing Balance</Option>
                    </Select>
            </FormItem>

            <FormItem 
                label="Loan Primary Schedule (Interest per day/weekly/monthly)"
                >
                    <Select 
                    value={this.state.loan_primary_schedule} 
                    onChange={(val)=>{this.setState({loan_primary_schedule:val})}}
                    placeholder="Loan Primary Schedule" >
                      <Option value='monthly'>Monthly</Option>
                      <Option value='weekly'>Weekly</Option>
                      <Option value='daily'>Daily</Option>
                    </Select>
            </FormItem>

            <FormItem label="Charges from">
                    <Select 
                    value={this.state.charges_from} 
                    onChange={(val)=>{this.setState({charges_from:val})}}
                    placeholder="Charges from" >
                      <Option value='loan'>Loan</Option>
                      <Option value='savings'>Savings</Option>
                    </Select>
            </FormItem>
 

            <FormItem label="loan limit (Applicant)" >
              <Input name="no_of_times_collateral_againstloanamount"  placeholder="x" value={this.state.no_of_times_collateral_againstloanamount} onChange={(val)=>{this.setState({no_of_times_collateral_againstloanamount:val.target.value})}} />
            </FormItem>


            <FormItem  label="Loan limit by">
                    <Select 
                    value={this.state.loan_limitby} 
                    onChange={(val)=>{this.setState({loan_limitby:val})}}
                    placeholder="Loan limit by" >
                      <Option value='collateral_value_division'>Loan limit by collateralvalue division </Option>
                      <Option value='collateral_value_multiplication'>Loan limit by collateralvalue multiplication</Option>
                    </Select>
            </FormItem>

            <FormItem label="Number of loan approvers"
                      
            >
              <Input  placeholder="0" value={this.state.no_of_approvers} onChange={(val)=>{this.setState({no_of_approvers:val.target.value})}} />
            </FormItem>


          <FormItem label="PMT formula enabled on reducing balance?" >
            <Switch
                checked={this.state.pmt_formular_enabled_onreducingbalance}
                onChange={val=>{this.setState({pmt_formular_enabled_onreducingbalance:val})}}
                checkedChildren="True"
                unCheckedChildren="False"
                />
        </FormItem>


        <FormItem label="Transfer to savings onissuance?" >
            <Switch
                checked={this.state.transfer_tosavings_onissuance}
                onChange={val=>{this.setState({transfer_tosavings_onissuance:val})}}
                checkedChildren="True"
                unCheckedChildren="False"
                />
        </FormItem>

        <h3>SMS sending settings</h3>


        <FormItem label="send sms on issuance?" >
            <Switch
                checked={this.state.send_sms_onissuance}
                onChange={val=>{this.setState({send_sms_onissuance:val})}}
                checkedChildren="True"
                unCheckedChildren="False"
                />
        </FormItem>

        <FormItem label="send sms on repayment?" >
            <Switch
                checked={this.state.send_sms_on_repayment}
                onChange={val=>{this.setState({send_sms_on_repayment:val})}}
                checkedChildren="True"
                unCheckedChildren="False"
                />
        </FormItem>

        <FormItem  label="SMS sending mode ">
              <Select 
              value={this.state.sms_balancesending_mode} 
              onChange={(val)=>{this.setState({sms_balancesending_mode:val})}}
              placeholder="SMS sending mode" >
                <Option value='principle_interest'>Total (principle & Interest) </Option>
                <Option value='principle_only '>Principle only</Option>
              </Select>
        </FormItem>


          <h3>Ledger account settings</h3>


<FormItem label={"Account_tocreditloanprinciple_ondeposit"}>
      <Select 
      placeholder="Account" 
      style={{  }} 
      value={this.state.account_tocreditloanprinciple_ondeposit}
      onChange={(val)=>{this.setState({account_tocreditloanprinciple_ondeposit:val})}} 
      showSearch
      optionFilterProp="children"
      onFocus={this.onFocus}
      onBlur={this.onBlur}
      onSearch={this.onSearch}                    
      >
        {this.state.companyaccounts.map(
          (accnt)=>(
            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
          ))}
      </Select>
  </FormItem>


  <FormItem label={"Account_tocreditloaninterestpaid_ondeposit"}>
      <Select 
      placeholder="Account" 
      style={{  }} 
      value={this.state.account_tocreditloaninterest_ondeposit}
      onChange={(val)=>{this.setState({account_tocreditloaninterest_ondeposit:val})}} 
      showSearch
      optionFilterProp="children"
      onFocus={this.onFocus}
      onBlur={this.onBlur}
      onSearch={this.onSearch}                    
      >
        {this.state.companyaccounts.map(
          (accnt)=>(
            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
          ))}
      </Select>
  </FormItem>



  <FormItem label={"Account_todebitloaninterestreceivable_ondeposit"}>
      <Select 
      placeholder="Account" 
      style={{  }} 
      value={this.state.account_todebitloaninterest_ondeposit}
      onChange={(val)=>{this.setState({account_todebitloaninterest_ondeposit:val})}} 
      showSearch
      optionFilterProp="children"
      onFocus={this.onFocus}
      onBlur={this.onBlur}
      onSearch={this.onSearch}                    
      >
        {this.state.companyaccounts.map(
          (accnt)=>(
            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
          ))}
      </Select>
  </FormItem>

<FormItem label={"Account_todebit_onloan_onloanissuance"}>
      <Select 
      placeholder="Account" 
      style={{  }} 
      value={this.state.account_todebit_onloan_onloanissuance}
      onChange={(val)=>{this.setState({account_todebit_onloan_onloanissuance:val})}} 
      showSearch
      optionFilterProp="children"
      onFocus={this.onFocus}
      onBlur={this.onBlur}
      onSearch={this.onSearch}                    
      >
        {this.state.companyaccounts.map(
          (accnt)=>(
            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
          ))}
      </Select>
  </FormItem>




  <h3>Loan fines credit accounts</h3>


  <FormItem label={"Account_todebit_on_acculatedloanfines"}>
      <Select 
      placeholder="Account" 
      style={{  }} 
      value={this.state.account_todebit_on_acculatedloanfines}
      onChange={(val)=>{this.setState({account_todebit_on_acculatedloanfines:val})}} 
      showSearch
      optionFilterProp="children"
      onFocus={this.onFocus}
      onBlur={this.onBlur}
      onSearch={this.onSearch}                    
      >
        {this.state.companyaccounts.map(
          (accnt)=>(
            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
          ))}
      </Select>
  </FormItem>


  <FormItem label={"Account_tocredit_on_paidloanfines"}>
      <Select 
      placeholder="Account" 
      style={{  }} 
      value={this.state.account_tocredit_on_paidloanfines}
      onChange={(val)=>{this.setState({account_tocredit_on_paidloanfines:val})}} 
      showSearch
      optionFilterProp="children"
      onFocus={this.onFocus}
      onBlur={this.onBlur}
      onSearch={this.onSearch}                    
      >
        {this.state.companyaccounts.map(
          (accnt)=>(
            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
          ))}
      </Select>
  </FormItem>

  <h3>Issuance Charges credit accounts</h3>

  <FormItem label={"Account_tocredit_onbankcharge_onloanissuance"}>
      <Select 
      placeholder="Account" 
      style={{  }} 
      value={this.state.account_tocredit_onbankcharge_onloanissuance}
      onChange={(val)=>{this.setState({account_tocredit_onbankcharge_onloanissuance:val})}} 
      showSearch
      optionFilterProp="children"
      onFocus={this.onFocus}
      onBlur={this.onBlur}
      onSearch={this.onSearch}                    
      >
        {this.state.companyaccounts.map(
          (accnt)=>(
            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
          ))}
      </Select>
  </FormItem>


  <FormItem label={"Account_tocredit_onloanfees_onloanissuance"}>
      <Select 
      placeholder="Account" 
      style={{  }} 
      value={this.state.account_tocredit_onloanfees_onloanissuance}
      onChange={(val)=>{this.setState({account_tocredit_onloanfees_onloanissuance:val})}} 
      showSearch
      optionFilterProp="children"
      onFocus={this.onFocus}
      onBlur={this.onBlur}
      onSearch={this.onSearch}                    
      >
        {this.state.companyaccounts.map(
          (accnt)=>(
            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
          ))}
      </Select>
  </FormItem>


    <FormItem label={"Account_tocredit_onreservefee"}>
      <Select 
      placeholder="Account" 
      style={{  }} 
      value={this.state.account_tocredit_onreservefee}
      onChange={(val)=>{this.setState({account_tocredit_onreservefee:val})}} 
      showSearch
      optionFilterProp="children"
      onFocus={this.onFocus}
      onBlur={this.onBlur}
      onSearch={this.onSearch}                    
      >
        {this.state.companyaccounts.map(
          (accnt)=>(
            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
          ))}
      </Select>
  </FormItem>


  <FormItem label={"Account_tocredit_onassessment_fees"}>
      <Select 
      placeholder="Account" 
      style={{  }} 
      value={this.state.account_tocredit_onassessment_fees}
      onChange={(val)=>{this.setState({account_tocredit_onassessment_fees:val})}} 
      showSearch
      optionFilterProp="children"
      onFocus={this.onFocus}
      onBlur={this.onBlur}
      onSearch={this.onSearch}                    
      >
        {this.state.companyaccounts.map(
          (accnt)=>(
            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
          ))}
      </Select>
  </FormItem>


  <FormItem label={"Account_tocredit_oninsurance_fee"}>
      <Select 
      placeholder="Account" 
      style={{  }} 
      value={this.state.account_tocredit_oninsurance_fee}
      onChange={(val)=>{this.setState({account_tocredit_oninsurance_fee:val})}} 
      showSearch
      optionFilterProp="children"
      onFocus={this.onFocus}
      onBlur={this.onBlur}
      onSearch={this.onSearch}                    
      >
        {this.state.companyaccounts.map(
          (accnt)=>(
            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
          ))}
      </Select>
  </FormItem>


  <FormItem label={"Account_tocredit_oncommitment_fee"}>
      <Select 
      placeholder="Account" 
      style={{  }} 
      value={this.state.account_tocredit_oncommitment_fee}
      onChange={(val)=>{this.setState({account_tocredit_oncommitment_fee:val})}} 
      showSearch
      optionFilterProp="children"
      onFocus={this.onFocus}
      onBlur={this.onBlur}
      onSearch={this.onSearch}                    
      >
        {this.state.companyaccounts.map(
          (accnt)=>(
            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
          ))}
      </Select>
  </FormItem>

  <FormItem label={"Account_tocredit_onagreement_fees"}>
      <Select 
      placeholder="Account" 
      style={{  }} 
      value={this.state.account_tocredit_onagreement_fees}
      onChange={(val)=>{this.setState({account_tocredit_onagreement_fees:val})}} 
      showSearch
      optionFilterProp="children"
      onFocus={this.onFocus}
      onBlur={this.onBlur}
      onSearch={this.onSearch}                    
      >
        {this.state.companyaccounts.map(
          (accnt)=>(
            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
          ))}
      </Select>
  </FormItem>


  <FormItem label={"Account_tocredit_onphotograph_fees"}>
      <Select 
      placeholder="Account" 
      style={{  }} 
      value={this.state.account_tocredit_onphotograph_fees}
      onChange={(val)=>{this.setState({account_tocredit_onphotograph_fees:val})}} 
      showSearch
      optionFilterProp="children"
      onFocus={this.onFocus}
      onBlur={this.onBlur}
      onSearch={this.onSearch}                    
      >
        {this.state.companyaccounts.map(
          (accnt)=>(
            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
          ))}
      </Select>
  </FormItem>


  <h3>Auto payment settings</h3>
      <FormItem label="Auto repayment after full cycle?" >
            <Switch
                checked={this.state.autoPayments_afterfullcycle}
                onChange={val=>{this.setState({autoPayments_afterfullcycle:val})}}
                checkedChildren="True"
                unCheckedChildren="False"
                />
        </FormItem>


      <FormItem>
          <Button  type="primary" htmlType="submit">Update</Button>
      </FormItem>
      </Form>
    
    </Card>


    <Modal              
      visible={this.state.dyform_model_visible}
      title={"Dynamic loan formfee form"}
      onCancel={()=>{this.setState({dyform_model_visible:false})}}
      style={{width:1000}}
      footer={[
        <Button key="back" onClick={()=>{this.setState({dyform_model_visible:false})}}>
          Cancel
        </Button>,
          <Button key="ok" type='primary' 
            onClick={()=>{
              this.setState({dyform_model_visible:false})
            }}>
          Update
        </Button>
        ]}
        >

    <Form
        onFinish={(event) => this.handleFormSubmit_listofformfees(event)}
    >
      <FormItem label="Range Name"
        name="range_name"
        rules={[
          {
            required: true,
            message: 'Please input name',
          },
        ]}
      >
        <Input name="range_name"  placeholder="Put a name here." value={this.state.range_name} onChange={(val)=>{this.setState({range_name:val.target.value})}} />
      </FormItem>

     

      <FormItem label="Range start value"
        name="range_start_value"
        rules={[
          {
            required: true,
            message: 'Please input value',
          },
        ]}    
      >
        <Input name="range_start_value" type='number'  placeholder="Range start value" value={this.state.range_start_value} onChange={(val)=>{this.setState({range_start_value:val.target.value})}} />
      </FormItem>

      <FormItem label="Range end value"
        name="range_stop_value"
        rules={[
          {
            required: true,
            message: 'Please input value',
          },
        ]}    
      >
        <Input name="range_stop_value" type='number'  placeholder="Range end value" value={this.state.range_stop_value} onChange={(val)=>{this.setState({range_stop_value:val.target.value})}} />
      </FormItem>

      <FormItem 
        label="Charge type"
        name="charge_type"
        rules={[
          {
            required: true,
            message: 'Please select charge type',
          },
        ]}
        >
            <Select 
            value={this.state.charge_type} 
            onChange={(val)=>{this.setState({charge_type:val})}}
            placeholder="Charge Type" >
                  <Option value='block'>Block</Option>
                  <Option value='percentage'>Percentage</Option>
            </Select>
        </FormItem>


        <FormItem label="Charge value"
        name="charge_value"
        rules={[
          {
            required: true,
            message: 'Please input value',
          },
        ]}    
      >
        <Input name="charge_value" type='number'  placeholder="Charge value" value={this.state.charge_value} onChange={(val)=>{this.setState({charge_value:val.target.value})}} />
      </FormItem>


      <FormItem>
        <Button  type="primary" htmlType="submit">Add to list</Button>
      </FormItem>

      </Form>
          
      
      </Modal>

    </div>

    )
    }

        
    }
}

export default LoanTypeDetail; 